var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClarityListLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1404 1404",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M585 311.996H936V389.996H585V311.996Z",
    className: "svgFill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M585 468H936V546H585V468Z",
    className: "svgFill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M585 623.998H936V701.998H585V623.998Z",
    className: "svgFill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M585 780.002H936V858.002H585V780.002Z",
    className: "svgFill"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M585 936H936V1014H585V936Z",
    className: "svgFill"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M429 311.996H507V389.996H429V311.996Z",
    className: "svgFill"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M429 468H507V546H429V468Z",
    className: "svgFill"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M429 623.998H507V701.998H429V623.998Z",
    className: "svgFill"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M429 780.002H507V858.002H429V780.002Z",
    className: "svgFill"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M429 936H507V1014H429V936Z",
    className: "svgFill"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1092 78.002H311.999C291.312 78.002 271.473 86.2198 256.845 100.848C242.217 115.475 233.999 135.315 233.999 156.002V1248C233.999 1268.69 242.217 1288.53 256.845 1303.16C271.473 1317.78 291.312 1326 311.999 1326H1092C1112.69 1326 1132.53 1317.78 1147.15 1303.16C1161.78 1288.53 1170 1268.69 1170 1248V156.002C1170 135.315 1161.78 115.475 1147.15 100.848C1132.53 86.2198 1112.69 78.002 1092 78.002ZM1092 1248H311.999V156.002H1092V1248Z",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClarityListLine);
export default __webpack_public_path__ + "static/media/clarity_list-line.14c827d8.svg";
export { ForwardRef as ReactComponent };